import {ChangeEventHandler, Dispatch, useCallback} from 'react';

type UseCreditCardNumberInputProps = {
  cardNumber: string[];
  setCardNumber: Dispatch<string[]>;
  setCardInputError: Dispatch<boolean>;
  setSubmitError?: Dispatch<{show: boolean; errorMsg: string}>;
};

const useCreditCardNumberInput = ({cardNumber, setCardNumber, setCardInputError, setSubmitError}: UseCreditCardNumberInputProps) => {
  const updateCardDigitsByIndex = useCallback(({index, value}: {index: string; value: string}) => {
    const position = Number(index);
    const newCardNumber = [...cardNumber];
    newCardNumber[position] = value;
    setCardNumber(newCardNumber);
  }, [cardNumber, setCardNumber]);

  const handleInputChange: ChangeEventHandler<HTMLInputElement> = useCallback(event => {
    setCardInputError(false);
    if (setSubmitError) {
      setSubmitError({show: false, errorMsg: ''});
    }
    const containsOnlyNumber = /^\d+$/.test(event.target.value);
    if (!containsOnlyNumber || event.target.value.length > 4) {
      event.target.value = event.target.value.slice(0, -1);
    }
    updateCardDigitsByIndex({index: event.target.id, value: event.target.value});
    if (event.target.value.length === 4) {
      const nextEl = document.getElementById(String(Number(event.target.id) + 1));
      if (nextEl instanceof HTMLInputElement) {
        nextEl.focus();
      }
    }
  }, [setCardInputError, setSubmitError, updateCardDigitsByIndex]);

  return {
    handleInputChange,
  };
};

export default useCreditCardNumberInput;
